export default __webpack_public_path__ + "fa2573e85ac6181cceb4104d309e20d8.jpg";